export enum DateFormatEnum {
  DATE_FORMAT = "YYYY/MM/DD",
  HOUR_MIN_FORMAT = "HH:mm",
  TIME_FORMAT = "HH:mm:ss",
  DATE_TIME_FORMAT = `YYYY/MM/DD HH:mm:ss`,
}
